import React, { useEffect, useState } from "react";
import Seo from "../../../Components/SeoComponent/Seo";
import Header from "../../../Components/Header";
import { useService } from "../../../context/ServiceContext";
import { Copy, FileJson, Info, ListCheck, Loader } from "lucide-react";
import { 
  Fingerprint, 
  Server, 
  User, 
  MapPin, 
  Building2, 
  Hash 
} from "lucide-react";
import {
  verifyVehicleHistory,
} from "../../../Services/ApiTestService/apiTestService";
import { fetchProfile } from "../../../Services/ApiTestService/aadharTestService";
import { showErrorToast, showSuccessToast } from "../../../utils/toastUtils";
import { isAlphanumeric, isNumeric } from "validator";

function VehicleServiceHistory() {
  const [isLoading, setIsLoading] = useState(false);
  const [response, setResponse] = useState(null);
  const { serviceName } = useService();

  const [vehicleNumber, setVehicleNumber] = useState("");
  const [inputError, setInputError] = useState(null);
  const [isJsonCopied, setIsJsonCopied] = useState(null);

  const [profileData, setProfileData] = useState(null);
  let apiResponse;

  const isAlpha = (value) => {
    if (!value) return false;

    return isAlphanumeric(String(value).trim(), "en-IN", { ignore: " " });
  };

  const handleCopy = (data) => {
    navigator.clipboard
      .writeText(JSON.stringify(data, null, 2))
      .then(() => showSuccessToast("Copied!"));

    setIsJsonCopied(true);
  };

  const hendleVehicleRcLogs = async () => {
    if (!profileData) return;

    const validate = isAlpha(vehicleNumber);

    if (!validate) {
      return setInputError(
        "⚠️ Please enter alpha numeric in vehicle No. field",
      );
    } 

    try {
      setInputError(null);
      setIsLoading(true);
      setResponse(null);

      const res = await verifyVehicleHistory({
        api_id: profileData.user_id,
        api_key: profileData.api_key,
        token_id: profileData.token_id,
        vehicle_num: vehicleNumber.trim(),
      });

      if (res) {
        apiResponse = res;
      }
      setResponse(apiResponse);

      if (res?.status?.code === 200) {
        showSuccessToast(res?.message || "Success");
      } else if (res?.status?.code === 422) {
        showErrorToast(res?.data?.message || "invalid details ");
      } else if (res?.status?.code === 500) {
        showErrorToast(res?.data?.message || "server error");
      } else if (!res.success) {
        showErrorToast(res?.data?.message || "verificaton failed");
      } else {
        showErrorToast(res?.data?.message || "something went wrong");
      }
    } catch (error) {
      console.error(error);
      showErrorToast("Server error");
    } finally {
      setIsLoading(false);
    }
  };

  // ---------------- FETCH PROFILE ----------------
  useEffect(() => {
    const loadProfile = async () => {
      try {
        setIsLoading(true);
        const res = await fetchProfile();
        setProfileData(res?.data || null);

        if (res) {
          console.log("profile", res);
        }
      } catch (error) {
        console.error(error);
        showErrorToast("Failed to fetch profile");
      } finally {
        setIsLoading(false);
      }
    };

    loadProfile();
  }, []);

  return (
    <>
      <Seo />
      <Header heading={serviceName} />

      {isLoading && (
        <div className="flex justify-center mt-6">
          <Loader className="animate-spin" />
        </div>
      )}

      <div className="w-full min-h-screen flex flex-col items-center justify-start pb-14">
        {/* ---------------- FORM ---------------- */}
        <div className=" max-w-3xl border rounded-md sm:p-6 mt-6 bg-white">
          <div className="flex items-center flex-col flex-wrap gap-4">
            {/* Vehicle */}
            <div className="flex items-center gap-4">
              <label className="w-32 font-bold">
                Vehicle No <span className="text-red-600">*</span>
              </label>
              <input
                type="text"
                maxLength={15}
                value={vehicleNumber}
                onChange={(e) => setVehicleNumber(e.target.value)}
                className="flex-1 border border-gray-400 rounded-md px-3 h-[38px]"
                placeholder="Eg: GJ08BN1256"
              />
            </div>

            {/* show input errors */}

            {inputError && (
              <div className="text-red-800 text-xl font-bold">{inputError}</div>
            )}

            {/* Verify Button */}
            <div className="flex justify-end ">
              <button
                disabled={isLoading || !vehicleNumber}
                onClick={hendleVehicleRcLogs}
                className="px-6 py-2 bg-gradient-to-br hover:bg-black active:bg-green-600 from-blue-400 to-blue-800 text-white rounded-sm disabled:opacity-50"
              >
                Verify
              </button>
            </div>
          </div>
        </div>

        {/* response message */}

        {response && (
          <div
            className={` ${response.status?.code === 500 || response.status?.code === 422 ? "text-red-500" : "text-green-600"} py-4 text-2xl font-bold`}
          >
            {response?.data?.message || response?.message}
          </div>
        )}

        {/* instructions */}

        <div className="w-full flex justify-center">
          <div className="bg-green-100 max-w-3xl border border-green-400 text-green-700 p-5 mt-12 rounded-2xl">
            <h3 className="font-bold flex items-center justify-start gap-2 text-lg mb-2">
              <Info /> Important Instructions{" "}
              <span className="text-red-600">*</span>
            </h3>

            <p className="text-sm leading-relaxed">
              Please enter a valid vehicle number. Clicking the Verify button.
              After successful verification, the system will return the response
              in structured format, including details associated with
              the provided details. You may review and copy the data for your
              reference or further use.
            </p>
          </div>
        </div>

        {/* ---------------- RESULT ---------------- */}
        {response?.status?.code === 200 && (
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mt-10 w-full max-w-6xl">
            {/* -------- JSON VIEW -------- */}
            <div className="bg-gray-900 relative text-green-300 p-4 rounded-md overflow-auto">
              <button
                onClick={() => handleCopy(response)}
                className="absolute text-white top-4 right-8"
              >
                {isJsonCopied ? "copied" : <Copy />}
              </button>
              <p className="font-bold mb-2 text-2xl flex items-center justify-start md:justify-center gap-2 text-white">
                <FileJson /> JSON response
              </p>
              <hr className="mb-8" />{" "}
              <pre className="text-[16px]">
                {JSON.stringify(response, null, 2)}
              </pre>
            </div>

           <VehicleDataDisplay response={response}/>
          </div>
        )}
      </div>
    </>
  );
}

export default VehicleServiceHistory;





const VehicleDataDisplay = ({ response }) => {
  // Safely extract the nested data
  const requestDetails = response?.data;
  const ownersList = requestDetails?.data || [];

  // Only render if status code is 200
  if (response?.status?.code !== 200) {
    return null; 
  }

  return (
    <div className="w-full max-w-6xl mx-auto px-6 py-2 bg-slate-50/50 rounded-2xl shadow-sm border border-slate-200">
      
      {/* Header Section */}
      <div className="flex flex-col items-center justify-center mb-2 text-center">
        <div className="inline-flex items-center justify-center p-3 bg-blue-100 rounded-xl mb-4">
          <ListCheck className="w-8 h-8 text-blue-600" />
        </div>
        <h2 className="text-3xl md:text-4xl font-extrabold text-slate-800 tracking-tight">
          Full Vehicle Data
        </h2>
        <div className="h-1.5 w-24 bg-gradient-to-r from-blue-500 to-indigo-500 rounded-full mt-5"></div>
      </div>

      {/* Meta Information Cards (Request IDs) */}
      <div className="grid grid-cols-1 gap-4 mb-10">
        <div className="flex items-center gap-4 p-5 bg-white rounded-xl shadow-sm border border-slate-100 hover:shadow-md transition-shadow duration-300">
          <div className="p-3 bg-blue-50 text-blue-600 rounded-lg">
            <Fingerprint className="w-6 h-6" />
          </div>
          <div className="overflow-hidden">
            <p className="text-xs font-bold text-slate-400 uppercase tracking-wider mb-1">
              Request ID
            </p>
            <p className="text-sm font-medium text-slate-700 truncate">
              {requestDetails?.requestId || "N/A"}
            </p>
          </div>
        </div>

        <div className="flex items-center gap-4 p-5 bg-white rounded-xl shadow-sm border border-slate-100 hover:shadow-md transition-shadow duration-300">
          <div className="p-3 bg-indigo-50 text-indigo-600 rounded-lg">
            <Server className="w-6 h-6" />
          </div>
          <div className="overflow-hidden">
            <p className="text-xs font-bold text-slate-400 uppercase tracking-wider mb-1">
              Client Request ID
            </p>
            <p className="text-sm font-medium text-slate-700 truncate">
              {requestDetails?.clientRequestId || "N/A"}
            </p>
          </div>
        </div>
      </div>

      {/* Owners Data Grid */}
      <div className="space-y-2">
        <h3 className="text-xl font-bold text-slate-800 flex items-center gap-2  pb-3">
          Ownership History
        </h3>
        
        <div className="grid grid-cols-1  gap-6 ">
          {ownersList.map((owner, index) => (
            <div 
              key={index} 
              className="relative bg-white px-6 py-2 rounded-2xl shadow-sm border border-slate-200 hover:shadow-xl hover:border-blue-300 transition-all duration-300 transform hover:-translate-y-1 group"
            >
              {/* Floating Ownership Badge */}
              <div className="absolute -top-3 -right-3 bg-gradient-to-r from-blue-600 to-indigo-600 text-white text-xs font-bold px-3 py-1.5 rounded-full shadow-lg flex items-center gap-1.5 border-2 border-white">
                <Hash className="w-3.5 h-3.5" />
                Owner {owner.owner_sr}
              </div>

              <div className="space-y-2 mt-2">
                {/* Owner Name */}
                <div className="flex items-start gap-3">
                  <div className="mt-1 p-2 bg-slate-50 text-slate-400 rounded-lg group-hover:bg-blue-50 group-hover:text-blue-600 transition-colors">
                    <User className="w-5 h-5" />
                  </div>
                  <div>
                    <p className="text-[11px] font-bold text-slate-400 uppercase tracking-wide">Owner Name</p>
                    <p className="text-base font-bold text-slate-800 leading-tight mt-0.5">
                      {owner.owner_name}
                    </p>
                  </div>
                </div>

                <div className="w-full h-px bg-slate-100"></div>

                {/* RTO Office */}
                <div className="flex items-start gap-3">
                  <div className="mt-1 p-2 bg-slate-50 text-slate-400 rounded-lg group-hover:bg-indigo-50 group-hover:text-indigo-600 transition-colors">
                    <Building2 className="w-5 h-5" />
                  </div>
                  <div>
                    <p className="text-[11px] font-bold text-slate-400 uppercase tracking-wide">RTO Office</p>
                    <p className="text-sm font-semibold text-slate-700 mt-0.5">
                      {owner.offName}
                    </p>
                  </div>
                </div>

                {/* State Code */}
                <div className="flex items-start gap-3">
                  <div className="mt-1 p-2 bg-slate-50 text-slate-400 rounded-lg group-hover:bg-emerald-50 group-hover:text-emerald-600 transition-colors">
                    <MapPin className="w-5 h-5" />
                  </div>
                  <div>
                    <p className="text-[11px] font-bold text-slate-400 uppercase tracking-wide">State Code</p>
                    <p className="text-sm font-semibold text-slate-700 mt-0.5">
                      {owner.stateCd}
                    </p>
                  </div>
                </div>
              </div>
              
            </div>
          ))}
        </div>
      </div>

    </div>
  );
};

